namespace $.$$ {

	$mol_style_define( $shm_hitalama_dragtree, {

		position: 'relative',

		New_pos: {
			position: 'absolute',
			right: 0,
			outline: '1px var(--mol_theme_focus) dashed',
			border: {
				radius: $mol_gap.round,
			},
			pointerEvents: 'none',
		},

		Panel: {
			position: 'relative',
			width: '100%',
		},

		Drag: {
			right: 0,
			width: 'auto',
		},

		Row: {
			alignItems: 'stretch',
			height: '40px',
			minHeight: '40px',
			maxHeight: '40px',
			position: 'relative',
			width: '100%',
		},

		Guides: {
			position: 'absolute',
			top: 0,
			bottom: 0,
			left: 0,
			width: 0,
			pointerEvents: 'none',
		},

		Drop_guides: {
			position: 'absolute',
			top: 0,
			bottom: 0,
			left: 0,
			width: 0,
			pointerEvents: 'none',
		},

		Guide: {
			position: 'absolute',
			background: {
				color: $mol_theme.line,
			},
		},

		Toggle: {
			position: 'absolute',
			left: 0,
			top: 0,
			bottom: 0,
			width: '1.5rem',
			minWidth: '1.5rem',
			maxWidth: '1.5rem',
			minHeight: 0,
			padding: 0,
			alignItems: 'center',
			justifyContent: 'center',
			margin: {
				left: '-1rem',
			},
		},

		Content: {
			flex: {
				grow: 1,
				shrink: 1,
			},
			width: '100%',
			minWidth: 0,
		},

		Item: {
			width: '100%',
			padding: {
				left: '1rem',
			},
		},

	} )

}
